module.exports = __webpack_public_path__ + "static/media/logo_full_white.d296e194.svg";